<div class="body">

    <p class="p-titulo">
        Quase Lá...
    </p>

    <div class="content" *ngIf="!isLoadingResults">

        <form [formGroup]="form">
   
            <div class="grid grid--auto-fill">
                
                <mat-form-field *ngIf="usuariosUnidade; else loading">

                    <mat-label>Usuário do cadastro</mat-label>

                    <mat-select formControlName="selecioneSeuLogin">

                         <mat-option *ngFor="let usuario of usuariosUnidade" [value]="usuario.id">
                            {{ usuario.userName }}
                         </mat-option>
                         
                     </mat-select>

                </mat-form-field>

            </div>

            <div class="div-botoes">
                    <button mat-raised-button class="b-cancelar" (click)="close()">
                        Cancelar
                    </button>

                    <button id="botaoenviar" mat-raised-button class="b-enviar" (click)="registrarAtendimento()">
                        Enviar
                    </button>
                </div>

        </form>

    </div>

</div>

<ng-template #loading>
    <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>